import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { SimpleActionModalComponent } from '../../shared/components/simple-action-modal/simple-action-modal.component';
import { ModalService } from '../../shared/services/modal/modal.service';
import { InventoryService } from '@inventory/services/inventory.service';

@Injectable({
  providedIn: 'root',
})
export class OfflineGuard {
  subject = new Subject<boolean>();

  constructor(
    private modalController: ModalController,
    private modalService: ModalService,
    private translateService: TranslateService,
    private inventorySerice: InventoryService,
  ) {}

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ): boolean | Observable<boolean | UrlTree> {
    let byPass = false;
    if (
      nextState?.url.includes('desktop') ||
      nextState?.url.includes('touch')
    ) {
      this.inventorySerice
        .inventoryOnline$()
        .pipe(take(1))
        .subscribe(online => {
          if (online) {
            byPass = true;
          } else {
            this.confirmDeactivate(nextState?.url.includes('touch'));
          }
        });
    } else {
      byPass = true;
    }
    if (byPass) {
      return true;
    } else {
      return this.subject.asObservable();
    }
  }

  async confirmDeactivate(isTouch: boolean) {
    this.modalService.setModalOptions(
      isTouch,
      SimpleActionModalComponent,
      {
        title: this.translateService.instant('i18n.leavePageModal.title'),
        content: this.translateService.instant(
          'i18n.leavePageModal.profileText',
        ),
        leftButtonText: this.translateService.instant('i18n.common.cancel'),
        rightButtonText: this.translateService.instant(
          'i18n.leavePageModal.leavePage',
        ),
        exitButtonForTablet: true,
        exitButtonForMobile: true,
      },
      'simple-action-modal',
    );
    const modal = await this.modalController.create(
      this.modalService.modalOptions,
    );
    modal.onDidDismiss().then((resp: any) => {
      const confirmed = !!resp.data?.dispatchAction;
      this.subject.next(confirmed);
    });
    return await modal.present();
  }
}
